import { Modal, ModalDialog, RadioGroup, Radio, Button } from "@mui/joy";
import React, { useEffect, useState } from "react";
import { postFetch } from "../../../fetch/fetch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const RewardWeightModal: React.FC<any> = (props) => {

    const [selected, setSelected] = useState<string>("100");
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (props.open) {
            setSelected(String(props.currentWeight || 100));
        }
    }, [props.open, props.currentWeight]);

    const submit = async () => {
        try {
            if (!props.questionId) return;

            setLoading(true);

            const result: any = await postFetch("/dashboard/question/rewardweight", {
                questionId: props.questionId,
                rewardWeight: +selected,
            });

            if (result.message === "success") {
                toast.success("가중치가 저장되었습니다.", {
                    position: "bottom-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    theme: "colored"
                });
                props.onSuccess(+selected);
                props.onClose();
            }

            setLoading(false);
        } catch (e) {
            console.log(e);
            setLoading(false);
        }
    };

    return (
        <Modal open={props.open} onClose={props.onClose}>
            <ModalDialog>
                <div style={{ width: "280px" }}>
                    <div style={{ fontSize: "18px", fontWeight: 600, marginBottom: "18px" }}>
                        보상 가중치 설정
                    </div>
                    <div style={{ fontWeight: 600, marginBottom: "9px" }}>
                        가중치 선택
                    </div>
                    <RadioGroup
                        orientation="horizontal"
                        value={selected}
                        onChange={(e: any) => setSelected(e.target.value)}
                    >
                        <Radio value="100" label={<span>100%</span>} />
                        <Radio value="150" label={<span>150%</span>} />
                        <Radio value="200" label={<span>200%</span>} />
                    </RadioGroup>
                    <div style={{ marginTop: "25px" }}>
                        <Button
                            variant="solid"
                            fullWidth
                            onClick={submit}
                            loading={loading}
                        >
                            저장하기
                        </Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default RewardWeightModal;
